<template>
    <div class="sidebar__section  sidebar__section--vertical-padding sidebar__section--border-bottom">
        <div class="poi-summary">
            <div class="poi-summary__top">
                <img class="poi-summary__image" :src="poi.image"/>
                <div class="poi-summary__content">

                    <div class="poi-summary__content__header ui-flex">
                        <div class="poi-summary__title h2">{{ poi.title }}</div>
                        <!-- <TrafficAlertButton v-if="poi.type === 'traffic'" /> -->
                        <MoreActions 
                            v-if="showActions"
                            :favourite-object="waypointData" 
                            :actions="actions"
                            :tooltips="tooltipsContent"
                            :tracking-favourite="poi.type"
                            :tracking-type="trackingType"
                            :tracking-name="poi.type"
                            @share="shareHandler"
                            @editFavourite="editFavouriteHandler"
                        />
                    </div>

                    <div class="poi-summary__texts">
                        <div class="ui-inline-block tag tag--yellow" v-if="poi.partnerTag">{{poi.partnerTag}}</div>
                        <div class="ui-inline-block tag tag--blue" v-if="poi.roadName">{{ poi.roadName }}</div>
                        <div class="ui-inline-block tag tag--blue" v-if="poi.country && poi.country.name">{{ poi.country.name }}</div>
                        <div class="poi-summary__infos copy-light">
                            <span class="dot-divider dot-divider--info" v-if="poi.address">{{ poi.address }}</span>
                            <span class="ui-nowrap dot-divider dot-divider--info" v-if="poi.categoryName">{{ poi.categoryName }}</span>
                            <span class="ui-nowrap dot-divider dot-divider--info" v-if="!poi.categoryName && poi.typeName">{{ poi.typeName }}</span>
                            <span class="ui-nowrap dot-divider dot-divider--info" v-if="poi.distance && showDistance">{{ poi.distance | formatDistance }}</span>
                            <span class="dot-divider dot-divider--info" v-if="poi.lastUpdated">aktualisiert: {{ poi.lastUpdated }}</span>
                            <span class="ui-nowrap dot-divider dot-divider--info" v-if="poi.coordinates">GPS: {{ poi.coordinates }}</span>
                            <span class="ui-nowrap dot-divider dot-divider--info" v-if="poi.openingTime" :class="poi.openingTime.color">{{ poi.openingTime.label }}</span>
                            <span class="ui-nowrap dot-divider dot-divider--info" v-if="poi.feeAvailability" :class="poi.feeAvailability.color">{{ poi.feeAvailability.label }}</span>
                            <span class="ui-nowrap dot-divider dot-divider--info" v-if="poi.availability" :class="poi.availability.color">{{ poi.availability.label }}</span>
                            <span class="ui-nowrap dot-divider dot-divider--info" v-if="poi.hourlyPrice">{{ poi.hourlyPrice.price }} {{ poi.hourlyPrice.label }}</span>
                            <span class="ui-nowrap dot-divider dot-divider--info" v-if="poi.maxDuration">{{ poi.maxDuration }}</span>
                        </div>
                        <div class="poi-summary__infos copy-light" v-if="poi.longDescription">
                            {{ poi.longDescription }}
                        </div>
                    </div>

                </div>
              
            </div>
            <AddLocationToWaypoints v-if="showAddToWaypointsButtons" @addToWaypoints="addToWaypointsHandler"/>

            <div class="poi-summary__button" v-if="showParkticketButton && mobile">
                <SmrButton @click.native="mobileParkingClickHandler">Parkschein buchen</SmrButton>
                <MobileParkingLinks />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import eventBus from '@/utils/event-bus';
import MoreActions from '@/components/MoreActions.vue'
import AddLocationToWaypoints from '@/components/AddLocationToWaypoints.vue'
// import TrafficAlertButton from '@/components/TrafficAlertButton.vue'
import { formatDistance } from '@/utils/format';
import SmrButton from '@/components/SmrButton.vue'
import MobileParkingLinks from '@/components/MobileParkingLinks.vue'
import { trackEvent, trackGa4Event } from '@/utils/tracking'
import { poiTracking } from '@/data/trackingInfo';

export default {
    components: {
        MoreActions,
        AddLocationToWaypoints,
        // TrafficAlertButton,
        SmrButton,
        MobileParkingLinks
    },
    props: {
        poi: {
            type: Object,
            default: () => {}
        },
        waypointData: {
            type: Object,
            default: () => {}
        },
        favourite: {
            type: [Object, Boolean],
            default: false
        }
    },
    filters: {
        formatDistance(val) {
            return formatDistance(val);
        }
    },
    data() {
        return {
            tooltipsContent: {
                moreActions: {
                    content: 'Weitere Optionen',
                    position: 'bottom-start'
                },
                favourites: {
                    full: {
                        content: 'Als Favorit entfernen',
                        position: 'right'
                    },
                    empty: {
                        content: 'Als Favorit speichern',
                        position: 'right',
                    }
                } 
            }
        }
    },
    computed: {
        ...mapGetters(['mobile', 'selectedPOIs']),
        actions() {
            // const label = this.favourite ? 'Favorit' : 'Ort';
            const actions = [ // todo: not real actions, designs missing
                // {
                //     icon: 'IconPdf',
                //     label: `${label} als PDF speichern / drucken`,
                //     event: 'printPdf'
                // },
                // {
                //     icon: 'IconShare',
                //     label: `${label} teilen`,
                //     event: 'share'
                // },
                // {
                //     icon: 'IconExport',
                //     label: `${label} exportieren`,
                //     event: 'export'
                // },
            ]

            if(this.favourite) {
                actions.unshift({
                    icon: 'IconEdit',
                    label: 'Favorit bearbeiten',
                    event: 'editFavourite',
                })
            }
            return actions
        },
        trackingType() {
            if(!this.poi.type && this.poi.categoryName === 'Arbeit' || !this.poi.type && this.poi.categoryName === 'Zuhause') {
                return this.poi.categoryName
            } else if(this.poi.categoryName !== 'Arbeit' || this.poi.categoryName !== 'Zuhause') {
                return 'Routes';
            } else {
                return false
            }
        },
        showAddToWaypointsButtons() {
            if(this.poi.type === 'carParks' && this.waypointData.category && this.waypointData.category.includes('PUBLIC')) {
                return false
            }
            return this.poi.type !== 'traffic' && this.poi.type !== 'camera' && this.poi.type !== 'shorttermparking' && this.poi.type !== 'greenzone' && this.poi.type !== 'tunnels' && this.poi.type !== 'travelRadar'
        },
        showActions() {
            if(this.poi.type === 'carParks' && this.waypointData.category && this.waypointData.category.includes('PUBLIC')) {
                return false
            }
            if(this.poi.type === 'traffic' && this.poi.subType === 'camera') return true
            return this.poi.type !== 'traffic' && this.poi.type !== 'greenzone' && this.poi.type !== 'shorttermparking' && this.poi.type !== 'travelRadar'
        },
        showParkticketButton() {
            if(this.poi.type === 'carParks' && this.waypointData.category && this.waypointData.category.includes('PUBLIC')) {
                return this.mobilePaymentOptions !== false
            }
            return this.poi.type === 'shorttermparking' && this.mobilePaymentOptions !== false
        },
        mobilePaymentOptions() {
            const paymentOptions = this.poi.paymentOptions ? this.poi.paymentOptions.options : false
            if(!paymentOptions) return false
            const mobilePaymentData = paymentOptions.find(option => option.type === 'MOBILE')
            return mobilePaymentData ? mobilePaymentData.values : false
        },
        showDistance() {
            if(this.poi.type === 'carParks' && this.poi.subType === 'shorttermparking') {
                return false
            }
            return this.poi.type !== 'greenzone' && this.poi.type !== 'shorttermparking'
        }
    },
    methods: {
        addToWaypointsHandler({position}) {
            let data = this.waypointData;
            this.$store.commit('setActivePoiId', false);
            eventBus.$emit('addLocationToWaypoints', { 
                waypoint: {...data},
                position: position,
                positionIndex: false,
                insertAfterIndex: false,
            })

            this.trackingEvent(position);
        },
        trackingEvent(position) {
            // if(position !== 'between')
                trackEvent(poiTracking(this.selectedPOIs, this.poi.categoryName, position, this.poi.type));
                trackGa4Event(poiTracking(this.selectedPOIs, this.poi.categoryName, position, this.poi.type));
        },
        shareHandler() {
            console.log('handle share');
        },
        editFavouriteHandler() {
            eventBus.$emit('showFavouritesPanel', this.favourite)
        },
        mobileParkingClickHandler() {
            if(this.mobilePaymentOptions) {
                eventBus.$emit('showMobileParkingLinks', this.mobilePaymentOptions)
            }
        }
    }
}
</script>

<style lang="scss">
.poi-summary {

    &__top {
        display: flex;
    }

    &__texts {
        .tag {
            & + .tag {
                margin-left: 6px;
            }
        }
    }

    &__content {
        flex-grow: 1;
    }

    &__infos {
        overflow: hidden;
        margin-top: 6px;
        display: flex;
        flex-wrap: wrap;
    }

    &__image {
        width: 24px;
        height: 24px;
        margin-right: 16px;
        flex-shrink: 0;
    }

    &__title {
        margin-top: 2px;
        margin-bottom: 6px;
        padding-right: 16px;
        flex-grow: 1;
    }

    &__roadname {
        display: inline-block;
    }

    &__button {
        margin: 24px -3px 0;
    }
}
</style>